import { Button, Dialog } from "@app/ui";
import { useI18n } from "../../lib/useI18n.js";
import { useBackupConfirmStore } from "../../stores/index.js";

/** Confirm popup for "Delete all". (Load uses BackupImportDialog.) */
export function BackupConfirmDialog() {
  const { t } = useI18n();
  const { open, pending, resolve } = useBackupConfirmStore();
  if (!pending) return null;

  return (
    <Dialog open={open} onClose={() => resolve("cancel")} title={t("backup.deleteAllTitle")} className="max-w-md">
      <div className="flex flex-col gap-4">
        <p className="text-sm text-foreground">{t("backup.deleteAllBody")}</p>
        <div className="flex flex-col gap-2">
          <Button variant="destructive" onClick={() => resolve("confirm")}>{t("backup.deleteEverything")}</Button>
          <Button variant="ghost" onClick={() => resolve("cancel")}>{t("common.cancel")}</Button>
        </div>
      </div>
    </Dialog>
  );
}
